import { Component } from 'react';
import { connect } from 'react-redux';
import { logout } from '../../actions';
import * as Msal from 'msal';
import * as MsalBrowser from '@azure/msal-browser';
import Url from "../../utils/url";

class Logout extends Component {

  UNSAFE_componentWillMount() {
    this.props.dispatch(logout());

    const ssoLoggedIn = localStorage.getItem("SsoLoggedIn");

    if (ssoLoggedIn && ssoLoggedIn === "true") {

      const ssoLogout = window.location.protocol + "//" + window.location.hostname + '/ui/login/ssologout';
      const msalRedirect = Url.addReturnUrlParameter(ssoLogout)
      const authCodeFlowEnabled = localStorage.getItem("SsoAuthFlowEnabled") === 'true';
      const config = {
        auth: {
          clientId: localStorage.getItem("sso-aId"),
          authority: localStorage.getItem("sso-aut"),
          validateAuthority: false,
          redirectUri: msalRedirect,
          postLogoutRedirectUri: msalRedirect,
          navigateToLoginRequestUrl: false
        },
        cache: {
          cacheLocation: "localStorage",
          storeAuthStateInCookie: true
        },
      }
      const logoutRequest = {
        postLogoutRedirectUri: config.auth.redirectUri,
      };
      if (authCodeFlowEnabled) {
        config.auth.knownAuthorities = [localStorage.getItem("sso-known-auth")]
        new MsalBrowser.PublicClientApplication(config).logoutRedirect(logoutRequest);
      } else {
        new Msal.UserAgentApplication(config).logout();
      }
    } else {
      const ssoEnabled = localStorage.getItem("SsoEnabled");
      if (ssoEnabled && ssoEnabled === "true") {
        const logoutUrl = window.location.protocol + "//" + window.location.hostname + '/ui/login/ssologout';
        const redirectUrl = Url.addReturnUrlParameter(logoutUrl)
        window.location.href = decodeURIComponent(redirectUrl);
      }
    }
  }

  render() {
    return null;
  }
}

export default connect()(Logout);
